import { Overline } from "@/components/landing/Shared";

const PREAMBLE = [
  "The website you are visiting, lawsuitsettlementhelp.com (the “Website”), is owned and operated by Lawsuit Settlement Help. Any use of this Website is subject to the Terms of Use, this Disclaimer, and the Privacy Policy. By using this Website, you agree to all of them. Please read them carefully.",
  "IF YOU USE THIS WEBSITE, YOU ARE DEEMED TO HAVE READ, UNDERSTOOD, AND AGREED TO THE TERMS OF USE, THIS DISCLAIMER, AND THE PRIVACY POLICY. IF YOU DO NOT ACCEPT THEM, YOU SHOULD STOP USING THE WEBSITE OR ANY MATERIALS OBTAINED FROM IT.",
];

const SECTIONS = [
  {
    title: "Nature of This Website",
    paragraphs: [
      "Lawsuit Settlement Help is a non-attorney marketing company. This website is a paid advertisement for legal services.",
      "Lawsuit Settlement Help is not a law firm or lawyer referral service. Lawsuit Settlement Help does not provide legal advice, legal services, or legal representation to anyone, including visitors to this Website or people responding to our advertisements.",
      "Lawsuit Settlement Help is a privately held company that provides fee-based marketing for law firm clients that offer legal services to individuals who allege they have been injured by certain drugs, medical devices, and products.",
      "The disclaimers on this page apply to: (1) users of this Website, (2) anyone who sees, hears, or responds to our advertisements, and (3) anyone who views or receives any marketing materials, emails, or other communications from Lawsuit Settlement Help or persons affiliated with Lawsuit Settlement Help (“Any Communication”).",
    ],
  },
  {
    title: "Participating Law Firms",
    paragraphs: [
      "Participating law firms vary for each campaign and change from time to time. Participating law firms are subject to change without notice.",
      "If there are multiple participating firms, matching of an initial inquiry to a specific law firm is done by an internal random process. Some cases may be transferred to other attorneys; discuss this with your attorney.",
    ],
  },
  {
    title: "Prescription Drug and Medical Device Notices",
    paragraphs: [
      "Do not stop taking a prescribed medication without first consulting with your doctor. Discontinuing a prescribed medication without your doctor's advice can result in injury or death.",
      "Do not base any medical decision on this or any other advertisement.",
      "As to campaigns related to prescription drugs: the subject drug remains approved by the FDA.",
      "As to campaigns related to medical devices: the subject medical device remains approved by the FDA.",
    ],
  },
  {
    title: "No Attorney-Client Relationship",
    paragraphs: [
      "Your initial contact may not be with a licensed attorney and does not constitute legal advice or create an attorney-client relationship. A participating law firm or their agent may evaluate your case, and that process does not establish an attorney-client relationship.",
      "Transmission of information about a potential claim to Lawsuit Settlement Help or to law firm clients of Lawsuit Settlement Help is not intended to create, and does not constitute, an attorney-client relationship. Viewing or hearing Any Communication, requesting additional information, or transmitting information back and forth should never be considered the formation of an attorney-client relationship.",
      "An attorney-client relationship will only be created by a written agreement between a law firm and a client.",
    ],
  },
  {
    title: "Confidentiality of Information",
    paragraphs: [
      "You understand and agree that any information you initially provide to Lawsuit Settlement Help, or to a law firm evaluating your case, is provided voluntarily and will not be considered or treated as confidential information until such law firm has been retained by you in writing.",
      "Because Lawsuit Settlement Help is not a law firm, such information will never be deemed or agreed to be confidential as to Lawsuit Settlement Help.",
    ],
  },
  {
    title: "Case Acceptance and Rejection",
    paragraphs: [
      "A participating law firm may accept or reject a case based on its sole discretion. Rejection of your case is not the expression of a legal opinion about your case; instead, you are encouraged to discuss the matter with any other law firm or attorney of your choice.",
    ],
  },
  {
    title: "Legal Fees and Costs",
    paragraphs: [
      "Clients will not be responsible for a legal fee unless there is a settlement in their favor or they win at trial. However, the client may be responsible for costs and any awarded costs and fees. Consult with your attorney.",
    ],
  },
  {
    title: "Advertising Notice",
    paragraphs: [
      "The statements made in Any Communication from Lawsuit Settlement Help do not fully state all the requirements needed for a successful case. Do not select an attorney or law firm solely based on an advertisement.",
      "No representation is made that the quality of legal services to be performed is greater than the quality of legal services performed by other lawyers, or that any attorney involved with this advertising or Any Communication is a licensed specialist of any state.",
      "Certain states may consider this an attorney advertisement for legal services paid for by a non-attorney spokesperson. Lawsuit Settlement Help is an advertising service and is not a law firm or lawyer referral service.",
      "You may be entitled to compensation if you or a loved one has been injured by a dangerous drug, medical device, or product. The choice of a lawyer is an important decision that should not be based solely upon advertisements. Results are not guaranteed.",
    ],
  },
  {
    title: "No Guarantee of Outcome",
    paragraphs: [
      "Any statement contained in Any Communication from us shall not constitute or act as a guarantee, warranty, or prediction regarding the ultimate outcome of any matter or legal proceeding.",
      "Lawsuit Settlement Help does not guarantee the accuracy of the information provided in Any Communication but believes it to be accurate. Do not use Any Communication from us as a substitute for seeking your own legal advice, and do not fail to make your own investigation of facts and claims or to seek advice from an appropriate professional where appropriate in your judgment.",
      "The material and data in Any Communication from us are general in nature and may not apply to your specific circumstances. Every case comes with its own set of unique circumstances and facts.",
    ],
  },
  {
    title: "If You Already Have an Attorney",
    paragraphs: [
      "Do not respond to us regarding a specific claim if you already have an attorney for that specific claim or campaign. If you do have an attorney for a specific claim or campaign, do not disclose to us any information regarding your attorney or the claim.",
    ],
  },
  {
    title: "Communications and Callbacks",
    paragraphs: [
      "By contacting Lawsuit Settlement Help or submitting an inquiry, you agree to receive a callback from up to two different legal service providers, even if you are on a “Do Not Call” registry. If there are multiple participating legal service providers, matching of an initial inquiry to a specific legal service provider is completed by an internal random process. Some cases may be transferred to other attorneys; discuss this with your attorney.",
      "Lawsuit Settlement Help is not otherwise affiliated with, and is not responsible for, the representations or services provided by the legal service providers.",
    ],
  },
  {
    title: "SMS Text Messaging Program",
    paragraphs: [
      "We value your privacy. Your mobile number will be used solely for sending text-message notifications and reminders relating to your inquiry. We may disclose information as necessary to comply with laws, regulations, or governmental requests, to avoid liability, or to safeguard our rights and property.",
      "When providing information for this text-messaging program, you agree to furnish accurate, complete, and true information and not to use a false or misleading name. If we believe such information is untrue, inaccurate, or incomplete, we may deny you access to this program.",
      "When you opt in to receive SMS/text messages, you may be contacted by Lawsuit Settlement Help and/or the relevant third parties receiving your inquiry — such as lead buyers, intake providers, or law firms — using the contact details you provided, consistent with the disclosures presented when you submitted your information.",
      "Message and data rates may apply, and message frequency may vary. Neither Lawsuit Settlement Help nor the mobile carriers are responsible or liable for delays in the receipt of, or undelivered, SMS messages connected with this program. Major U.S. carriers are generally supported; availability may vary by carrier.",
    ],
  },
  {
    title: "Third-Party Affiliation and Liability",
    paragraphs: [
      "This website is not affiliated with any pharmaceutical company, medical device company, or product manufacturer referenced in any advertising or campaign.",
      "By visiting this Website or responding to our advertisements, you agree that Lawsuit Settlement Help is not responsible or liable for any claim, loss, or damage of any kind, directly or indirectly resulting from your use of any law firm, legal advice, or any information obtained from Lawsuit Settlement Help. By using this Website, you expressly acknowledge your understanding of and agreement to all of the disclaimers contained on this page.",
    ],
  },
  {
    title: "Medical Decisions",
    paragraphs: [
      "You should not rely upon any information on this Website as legal or medical advice. Any medical decision is important. Please consult your physician before altering the usage of any drug.",
    ],
  },
];

export default function Disclaimer() {
  return (
    <main data-testid="disclaimer-page" className="min-h-screen bg-[#FBF9F5] text-[#1A1715]">
      <div className="mx-auto max-w-3xl px-5 sm:px-10 py-20 sm:py-28">
        <Overline>Legal</Overline>
        <h1 className="mt-4 font-serif font-semibold text-4xl sm:text-5xl tracking-tight">
          Disclaimer
        </h1>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#78716C]">
          Effective Date: August 20, 2026 · lawsuitsettlementhelp.com
        </p>
        <div className="mt-8 space-y-4">
          {PREAMBLE.map((p) => (
            <p key={p.slice(0, 24)} className="font-news text-base text-[#44403C] leading-relaxed">
              {p}
            </p>
          ))}
        </div>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s, i) => (
            <section key={s.title}>
              <h2 className="font-serif font-semibold text-2xl">
                <span className="font-serif italic text-[#B45309]/50 mr-3">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.title}
              </h2>
              {s.paragraphs?.map((p) => (
                <p key={p.slice(0, 24)} className="mt-3 font-news text-base text-[#44403C] leading-relaxed">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
        <div className="mt-14 flex flex-wrap gap-6">
          <a
            href="/"
            data-testid="disclaimer-back-link"
            className="inline-block font-sans text-sm font-semibold text-[#C2410C] border-b border-[#C2410C] pb-1 hover:text-[#9A3412] transition-colors"
          >
            ← Back to homepage
          </a>
          <a
            href="/terms-of-use"
            data-testid="disclaimer-terms-link"
            className="inline-block font-sans text-sm font-semibold text-[#44403C] border-b border-[#E7E2DA] pb-1 hover:text-[#C2410C] transition-colors"
          >
            Terms of Use
          </a>
          <a
            href="/privacy-policy"
            data-testid="disclaimer-privacy-link"
            className="inline-block font-sans text-sm font-semibold text-[#44403C] border-b border-[#E7E2DA] pb-1 hover:text-[#C2410C] transition-colors"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </main>
  );
}
